var _dec, _class, _CTA;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from '@instructure/ui-buttons';
import { IconRecordLine, IconStopLine } from '@instructure/ui-icons';
import { withStyle, jsx } from '@instructure/emotion';
import * as CaptureActions from '../../../actions';
import { RECORDING, READY, STARTING, LOADING, PAUSED } from '../../../constants/CaptureStates';
import { translate } from '../../../constants/translated/translations';
import { getCaptureMode, getTrackerModeByCaptureMode } from '../../../utils';
import generateStyle from './styles';

/**
---
private: true
---
**/
/* eslint-disable react/prop-types */
let CTA = (_dec = withStyle(generateStyle, null), _dec(_class = (_CTA = class CTA extends Component {
  constructor(...args) {
    super(...args);
    this.onFinish = () => {
      this.props.actions.finishClicked();
    };
    this.onStart = () => {
      this.props.actions.startClicked();
    };
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  getInteractionType() {
    return this.props.isDisabled ? 'disabled' : 'enabled';
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      screenSharingActive = _this$props.screenSharingActive,
      videoDeviceId = _this$props.videoDeviceId,
      audioDeviceId = _this$props.audioDeviceId;
    switch (this.props.captureState) {
      case RECORDING:
      case PAUSED:
        return this.renderButton({
          text: translate('FINISH'),
          action: this.onFinish,
          styles,
          id: 'screen_capture_finish_button',
          icon: IconStopLine,
          passThroughHtmlAttrs: {
            'data-is-screen-share': screenSharingActive,
            'data-is-webcam': !!videoDeviceId,
            'data-is-mic': !!audioDeviceId,
            'data-capture-mode': getTrackerModeByCaptureMode(getCaptureMode({
              screenSharingActive,
              videoDeviceId,
              audioDeviceId
            }))
          }
        });
      case READY:
      case STARTING:
      case LOADING:
        return this.renderButton({
          text: translate('START'),
          action: this.onStart,
          icon: IconRecordLine,
          styles,
          id: 'screen_capture_start_button'
        });
      default:
        return null;
    }
  }
  renderButton({
    text,
    action,
    icon,
    id,
    passThroughHtmlAttrs
  }) {
    return jsx(Button, Object.assign({
      display: "block",
      textAlign: "center",
      onClick: action,
      color: "primary",
      size: "medium",
      interaction: this.getInteractionType(),
      id: id,
      renderIcon: icon,
      themeOverride: {
        iconSizeMedium: '1.125rem'
      }
    }, passThroughHtmlAttrs), text);
  }
}, _CTA.propTypes = {
  isDisabled: PropTypes.bool
}, _CTA.defaultProps = {
  isDisabled: false
}, _CTA)) || _class);
const mapStateToProps = state => ({
  captureState: state.captureState,
  screenSharingActive: state.screenSharingActive,
  videoDeviceId: state.videoDeviceId,
  audioDeviceId: state.audioDeviceId
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(CaptureActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(CTA);